// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__Footer__Kzbfj","Fixed":"Footer__Fixed__2oOKm","Link":"Footer__Link__P-w22"};